module.exports = __webpack_public_path__ + "static/img/有研.52bde64.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/有研.jpg
// module id = X0ML
// module chunks = 1